<template>
  <div class="mit-home-page mit-page">

      <v-container fluid>
      <v-row no-gutters>
        <v-col cols="12" class="d-flex">
          <v-card class="mit-info-card">
            <v-card-title>Account</v-card-title>
            <v-card-subtitle class="caption">CSAIL Account Management</v-card-subtitle>
            <v-divider></v-divider>

            <v-card-text>
              <div v-if="featureToggleWifiPassMoveToTop">
                  <!-- Temporary for the transfer of wifi -->
                  <div v-if="featureToggleWifiPass" class="container">
                    <h3 class="pt-5">
                      Manage WiFi Password
                    </h3>
                    <p>Set or Change your CSAIL WiFi password. </p>
                    <v-btn color="primary" to="/wifi/password/change">Set/Change</v-btn>
                  </div>
                  <v-container v-if="featureToggleChangePassword"> 
                    <h3 class="pt-5">
                      Change your OIDC/Kerberos Password
                    </h3>
                    <p>Change your OIDC/Kerberos CSAIL login account password. </p>
                    <v-btn color="primary" to="/password/change">Change</v-btn>
                  </v-container>
              </div>
              <div v-else>
                  <!-- Temporary for the transfer of wifi -->
                  <v-container v-if="featureToggleChangePassword"> 
                    <h3 class="pt-5">
                      Change your OIDC/Kerberos Password
                    </h3>
                    <p>Change your OIDC/Kerberos CSAIL login account password. </p>
                    <v-btn color="primary" to="/password/change">Change</v-btn>
                  </v-container>
                  <div v-if="featureToggleWifiPass" class="container">
                    <h3 class="pt-5">
                      Manage WiFi Password
                    </h3>
                    <p>Set or Change your CSAIL WiFi password. </p>
                    <v-btn color="primary" to="/wifi/password/change">Set/Change</v-btn>
                  </div>
              </div>
            <v-container>
              <h3 class="pt-5">
                INQUIR — CSAIL’s account management tool ...
              </h3>
              <p>Manage your email forwarding and personal information, renew your supervisees’ accounts, and create email aliases </p>
              <v-btn color="primary" href="https://inquir.csail.mit.edu/" target="_blank" >Go<v-icon class="ml-5" small> mdi-open-in-new</v-icon></v-btn>
            </v-container>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import BaseMitConfigService from '../../base/services/BaseMitConfigService.js';

  export default {
    name: 'MitHomePage',
    components: {
    },
    data: function() {
      return {
        featureToggleChangePassword:true,
        featureToggleWifiPass:false,
        featureToggleWifiPassMoveToTop:false
      }
    },
    created() {
      this.featureToggleChangePassword = BaseMitConfigService.getFeatureEnabled('feature-change-password');
      this.featureToggleWifiPass = BaseMitConfigService.getFeatureEnabled('feature-toggle-wifi-pass');
      this.featureToggleWifiPassMoveToTop = BaseMitConfigService.getFeatureEnabled('feature-wifi-pass-move-to-top');
    },
    methods: {
      // exampleFunction: function(model) {
      //   console.log(model);
      // }
    }
  }
</script>

<style lang="scss" scoped>
  .mit-info-card {
    width:100%;
    height:100%;
  }
  .container {
    margin-bottom: 20px;
    background-color: #ececec;
    border: 1px solid #ccc;
    border-radius: 2px;
    max-width: 100%;
  }
</style>
